import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/auth/accedi/AccediClient.tsx");
